import { Modal, ModalHeader, ModalBody } from "reactstrap";
import React, { Component, Fragment } from "react";
import { Button } from "react-bootstrap";

class AddressNotes extends Component {
  state = { modal: false };

  toggle = (e) => {
    e.preventDefault();

    this.setState({ modal: !this.state.modal });
  };

  render() {
    let { address, extraClasses } = this.props;
    if (extraClasses) {
      extraClasses = " " + extraClasses;
    }

    return (
      <>
        <span
          className={"text-success fas fa-info-circle" + extraClasses}
          onClick={this.toggle}
        ></span>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Address Notes</ModalHeader>
          <ModalBody style={{ whiteSpace: "pre-wrap" }}>
            {address.notes}
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default AddressNotes;
